<template>
  <div v-if="must_be_shown">
    <div
      class="chat-button"
      @click="toggleChat"
      :data-tooltip="$t('assistant')"
    >
      <span class="icon" v-if="!isChatOpen">
        <i class="fa fa-android"></i>
      </span>
      <span v-else>
        <i class="fa fa-times"></i>
      </span>
    </div>
    <div v-show="isChatOpen" class="chat-window box p-0">
      <div v-if="mode == 'chat'">
        <header class="chat-header">
          <div
            class="button is-small is-pulled-right is-rounded"
            @click="mode = 'configure'"
          >
            <span class="icon is-small">
              <i class="fa fa-cogs"></i>
            </span>
          </div>
          <p class="has-text-weight-bold has-text-white" v-if="personality">
            {{ personality.name }}
          </p>
          <p v-else class="has-text-weight-bold has-text-white">
            {{ $t("select a personality") }}
          </p>
        </header>
        <section class="chat-body" ref="chat_body">
          <div
            v-if="personality"
            class="box p-2 mb-2 has-text-white has-text-right"
            style="background-color: rgba(127, 139, 137, 0.21)"
          >
            <article class="media">
              <div class="media-content">
                <div class="content">
                  <p>
                    <span v-if="personality.first_message">{{
                      personality.first_message
                    }}</span>
                  </p>
                </div>
              </div>
            </article>
          </div>
          <div
            class="box p-2 mb-2 has-text-white"
            :style="
              message.role == 'user'
                ? 'background-color: rgba(0, 209, 178, 0.5)'
                : 'background-color: rgba(127, 139, 137, 0.21)'
            "
            :class="{
              'has-text-right': message.role === 'assistant',
            }"
            v-for="(message, index) in messages"
            :key="index"
          >
            <article class="media">
              <div class="media-content">
                <div class="content">
                  <p>
                    <!-- <strong>{{ $t(message.role) }}</strong>
                  <br /> -->
                    <span v-if="message.role == 'user'">{{
                      message.content
                    }}</span>
                    <span v-else-if="message.role == 'assistant'">
                      <div>
                        {{ message.content }}
                      </div>
                      <!-- <span
                      v-html="JSON.parse(message.content).customer_response"
                    ></span> -->
                    </span>
                  </p>
                </div>
              </div>
            </article>
          </div>
        </section>
        <footer class="chat-footer">
          <div class="field has-addons">
            <div class="control is-expanded has-icons-left has-icons-right">
              <input
                class="input is-rounded"
                type="text"
                :placeholder="$t('write a message')"
                v-model="userMessage"
                ref="userMessageInput"
                @keyup.enter="send_prompt"
              />
              <span class="icon is-small is-left">
                <i class="fa fa-terminal"></i>
              </span>
            </div>
            <div class="control">
              <button
                :disabled="
                  !personality || !userMessage || userMessage.trim() === ''
                "
                class="button is-primary is-right is-rounded"
                @click="send_prompt"
              >
                <span class="icon is-small">
                  <i class="fa fa-send"></i>
                </span>
              </button>
            </div>
          </div>
        </footer>
      </div>
      <div v-show="mode == 'configure'">
        <header class="chat-header">
          <!-- <div class="button is-small is-pulled-right" @click="mode = 'chat'">
            <span class="icon is-small">
              <i class="fa fa-arrow-left"></i>
            </span>
          </div> -->
          <p class="has-text-weight-bold has-text-white">
            {{ $t("assistant configuration") }}
          </p>
        </header>
        <section class="chat-body">
          <div class="content">
            <generic-dropdown
              :title="$t('personality')"
              :placeholder="$t('select one')"
              :is_multiple="false"
              url="/assistant/personality/catalog"
              name_field="name"
              value_field="uuid"
              @selected="personality_changed"
              ref="personality_dropdown"
            />
          </div>
        </section>
        <footer class="chat-footer">
          <div class="buttons are-small">
            <div class="button is-primary" @click="save_configuration">
              <span class="icon is-small">
                <i class="fa fa-check"></i>
              </span>
              <span>{{ $t("apply") }}</span>
            </div>
            <div class="button is-danger" @click="mode = 'chat'">
              <span class="icon is-small">
                <i class="fa fa-times"></i>
              </span>
              <span>{{ $t("cancel") }}</span>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { api_host, get, get_user_data } from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import { io } from "socket.io-client";

export default {
  name: "AssistantPlugin",
  components: { GenericDropdown },
  data() {
    return {
      show_assistant: false,
      isChatOpen: false,
      userMessage: "",
      messages: [],
      mode: "chat", // 'chat' or 'configure'
      personality: undefined,
      selected_personality: undefined,
      socket: null,
      current_conversation: null,
      must_be_shown: false,
    };
  },
  computed: {
    // must_be_shown() {
    //   let v = this;
    //   const data = localStorage.getItem("login_data");
    //   if (!data) return false;
    //   let json_data = JSON.parse(data);
    //   if (!json_data) return false;
    //   let assistant = json_data.assistant;
    //   if (!assistant || assistant == "NOT_AVAILABLE") return false;
    //   else return true;
    // },
    default_assistant_uuid() {
      let v = this;
      const data = localStorage.getItem("login_data");
      if (!data) return false;
      let json_data = JSON.parse(data);
      if (!json_data) return false;
      let assistant = json_data.assistant;
      if (!assistant || assistant == "NOT_AVAILABLE") return false;
      else return assistant;
    },
    user_data() {
      return get_user_data();
    },
  },
  methods: {
    toggleChat() {
      let v = this;
      v.isChatOpen = !v.isChatOpen;
      if (v.isChatOpen) {
        v.refresh();
        v.$nextTick(() => {
          v.$refs.userMessageInput.focus();
        });
      }
    },
    calculate_visibility() {
      let v = this;
      const data = localStorage.getItem("login_data");
      if (!data) {
        v.must_be_shown = false;
        return;
      }
      let json_data = JSON.parse(data);
      if (!json_data) {
        v.must_be_shown = false;
        return;
      }
      let assistant = json_data.assistant;
      if (!assistant || assistant == "NOT_AVAILABLE") {
        v.must_be_shown = false;
        return;
      } else {
        v.must_be_shown = true;
      }
    },
    refresh() {
      let v = this;
      v.calculate_visibility();
      // Fetch user data or any other initialization logic
      const data = localStorage.getItem("login_data");
      if (!data) {
        v.show_assistant = false;
        return;
      }
      let json_data = JSON.parse(data);
      let assistant = json_data.assistant;
      if (!data || !assistant) {
        v.show_assistant = false;
        return;
      } else {
        if (assistant == "NOT_AVAILABLE") v.show_assistant = false;
        else {
          v.show_assistant = true;
          setTimeout(() => {
            if (v.$refs.personality_dropdown) {
              v.$refs.personality_dropdown.set_value(assistant);
              setTimeout(() => {
                v.save_configuration();
              }, 2000);
            }

            // v.personality_changed(
            //   {
            //     uuid: assistant,
            //   },
            //   true
            // );
          }, 300);

          // v.$refs.personality_dropdown.set_value(assistant);
        }
      }
    },
    personality_changed(personality, autoload = false) {
      let v = this;
      if (personality) {
        v.selected_personality = personality;
        get("/assistant/plugin/chat", {
          personality_uuid: personality.uuid,
        })
          .then((r) => {
            if (!v.socket) v.initialize_socket();
            if (r) {
              v.current_conversation = r;
              if (autoload) v.save_configuration();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {});
      }
    },
    save_configuration() {
      let v = this;
      v.personality = v.selected_personality;
      if (v.current_conversation && v.current_conversation.messages)
        v.messages = v.current_conversation.messages.map((m) => {
          return {
            role: m.role,
            content:
              m.role == "assistant" ? m.content.final_response : m.content,
          };
        });
      if (v.$refs.personality_dropdown) v.$refs.personality_dropdown.clear();
      v.mode = "chat";
      setTimeout(() => {
        v.scrollToBottom();
      }, 100);
    },
    initialize_socket() {
      let v = this;
      v.socket = io(api_host); // Replace with your server URL

      v.socket.on("assistant_personal_chat", (message) => {
        v.messages.push(message);
        v.scrollToBottom();
      });
      v.socket.on("assistant_personal_chat_result", (message) => {
        v.messages.push({ ...message, automatic: true });
        v.scrollToBottom();
      });

      v.socket.on("connect_error", (error) => {
        console.error("Socket connection error:", error);
      });
    },
    scrollToBottom() {
      let v = this;
      if (!v.$refs.chat_body) return;
      // Wait for the DOM to update before scrolling
      v.$nextTick(() => {
        v.$refs.chat_body.scrollTop =
          v.$refs.chat_body.scrollHeight - v.$refs.chat_body.clientHeight;
      });
    },
    send_prompt() {
      let v = this;
      // v.$root.loader(true);

      let data = {
        prompt: v.userMessage,
        personality_uuid: v.personality.uuid,
        messages: v.messages.filter((m) => m.automatic != true),
        conversation_id: v.current_conversation
          ? v.current_conversation.conversation_id
          : null,
      };
      // console.log("data", data);
      v.socket.emit("assistant_personal_chat", data);
      v.messages.push({
        role: "user",
        content: v.userMessage,
      });
      v.userMessage = "";
      v.$refs.userMessageInput.focus();
      // // Clear the input field
      // this.userMessage = "";
      v.scrollToBottom();
    },
  },
  mounted() {
    let v = this;
    v.calculate_visibility();
    // if (v.must_be_shown) v.refresh();
  },
};
</script>

<style scoped>
.chat-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: rgba(0, 209, 178, 0.5);
  color: white;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  /* box-shadow: 0 0 2px 5px rgba(0, 209, 178, 0.9); */
}

.chat-window {
  position: fixed;
  bottom: 80px;
  right: 20px;
  width: 300px;
  max-height: 600px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 5px 2px rgba(0, 209, 178, 0.9);
  /* box-shadow: 0 0 5px 2px rgba(0,209,178,0.9); */
}

.chat-header {
  /* background-color: #00d1b2; */
  background-color: #2c2c2c;
  color: white;
  padding: 10px;
  text-align: center;
  border-radius: 10px 10px 0 0;
}

.chat-body {
  flex: 1;
  overflow-y: auto;
  min-height: 300px;
  max-height: 460px;
  padding: 10px;
  background-color: #313131;
}

.message {
  margin-bottom: 10px;
}

.message.is-user {
  text-align: right;
  color: #3273dc;
}

.message.is-assistant {
  text-align: left;
  color: #363636;
}

.chat-footer {
  display: flex;
  padding: 10px;
  background-color: #313131;
  border-top: 1px solid #ddd;
  border-radius: 0 0 10px 10px;
}

.chat-footer .input {
  flex: 1;
  margin-right: 10px;
}
</style>
